var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnNavClose = function SvgIcnNavClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20086 4.25363C5.81034 3.86311 5.17718 3.86311 4.78665 4.25363C4.39613 4.64416 4.39613 5.27732 4.78665 5.66785L10.6065 11.4877L4.25485 17.8394C3.86432 18.2299 3.86432 18.8631 4.25485 19.2536C4.64537 19.6442 5.27854 19.6442 5.66906 19.2536L12.0207 12.9019L18.3724 19.2536C18.763 19.6442 19.3961 19.6442 19.7867 19.2536C20.1772 18.8631 20.1772 18.2299 19.7867 17.8394L13.435 11.4877L19.2548 5.66784C19.6454 5.27732 19.6454 4.64415 19.2548 4.25363C18.8643 3.86311 18.2312 3.86311 17.8406 4.25363L12.0207 10.0735L6.20086 4.25363Z",
    fill: "#A4A7AD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnNavClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_nav_close.4eb49a65.svg";
export { ForwardRef as ReactComponent };